module.exports = __webpack_public_path__ + "static/media/bd-desk-pc-staff-member.daf33cd4.jpg";